// Helpers de fecha compartidos para los filtros estilo "Historia de clientes":
// presets de rango, máscara DD/MM/AAAA con barras automáticas, validación.

export const PRESETS_FECHA = [
  { key: 'todos', label: 'Todos los tiempos' },
  { key: '30', label: 'Últimos 30 días' },
  { key: '90', label: 'Últimos 90 días' },
  { key: 'actual', label: 'Año actual' },
  { key: 'anterior', label: 'Año anterior' },
]

export function rangoPreset(key) {
  const hoy = new Date()
  if (key === 'todos') return { d: '', h: '' } // sin límite → todos los movimientos
  if (key === 'hoy') return { d: fmtFecha(hoy), h: fmtFecha(hoy) }
  if (key === 'ayer') { const a = new Date(); a.setDate(a.getDate() - 1); return { d: fmtFecha(a), h: fmtFecha(a) } }
  if (key === '30' || key === '90') {
    const d = new Date(); d.setDate(d.getDate() - Number(key))
    return { d: fmtFecha(d), h: fmtFecha(hoy) }
  }
  if (key === 'actual') return { d: `01/01/${hoy.getFullYear()}`, h: fmtFecha(hoy) }
  const y = hoy.getFullYear() - 1
  return { d: `01/01/${y}`, h: `31/12/${y}` }
}

// Máscara DD/MM/AAAA: inserta las barras solas a medida que se tipea.
export function maskFecha(v) {
  const d = (v || '').replace(/\D/g, '').slice(0, 8)
  let out = d.slice(0, 2)
  if (d.length >= 3) out += '/' + d.slice(2, 4)
  if (d.length >= 5) out += '/' + d.slice(4, 8)
  return out
}

export function fmtFecha(d) {
  return `${String(d.getDate()).padStart(2, '0')}/${String(d.getMonth() + 1).padStart(2, '0')}/${d.getFullYear()}`
}

// "DD/MM" sin año (mes de 1 o 2 dígitos) → completa con el año en curso.
// Devuelve DD/MM/AAAA, o '' si el texto no tiene esa forma o el día no existe
// (31/02 no se convierte en una fecha inventada).
export function completarAnioFecha(s) {
  const m = /^(\d{2})\/(\d{1,2})$/.exec(s || '')
  if (!m) return ''
  const dia = Number(m[1]); const mes = Number(m[2]); const anio = new Date().getFullYear()
  const f = new Date(anio, mes - 1, dia)
  if (f.getMonth() !== mes - 1 || f.getDate() !== dia) return ''
  return `${m[1]}/${String(mes).padStart(2, '0')}/${anio}`
}

// Vacío = válido (sin filtro); si hay algo, debe tener formato completo.
export function validFechaOpt(s) { return s === '' || /^\d{2}\/\d{2}\/\d{4}$/.test(s || '') }

// Conversores para el calendario nativo (<input type="date"> usa YYYY-MM-DD).
export function fechaToISO(s) {
  const m = /^(\d{2})\/(\d{2})\/(\d{4})$/.exec(s || '')
  return m ? `${m[3]}-${m[2]}-${m[1]}` : ''
}
export function isoToFecha(s) {
  const m = /^(\d{4})-(\d{2})-(\d{2})$/.exec(s || '')
  return m ? `${m[3]}/${m[2]}/${m[1]}` : ''
}

// Hoy en formato DD/MM/AAAA (default de los filtros).
export function hoyFecha() { return fmtFecha(new Date()) }
